import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Tab } from '../../models/tab';
import { Subscription } from 'rxjs/Rx';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { DexieService } from '../../services/dexie.service';
import { SceneService } from '@services';
import { ActivatedRoute } from '@angular/router';
import Dexie from 'dexie';
import { Hotspot, Scene, Segment } from '@models';
import { current } from 'codelyzer/util/syntaxKind';

declare let cordova;

/**
 * (c) it.x informationssysteme gmbh, Alle Rechte vorbehalten.
 *
 * Content Component.
 */
@Component({
	selector: 'app-tab',
	templateUrl: './tab.component.html',
	styleUrls: ['./tab.component.scss']
})
export class TabComponent implements OnInit, OnDestroy
{
	/**
	 * Environment.
	 */
	public environment = environment;

	/**
	 * Cordova.
	 */
	public cordova;

	/**
	 * Tab.
	 */
	@Input()
	public tab: Tab;

	/**
	 * Store in IndexedDB.
	 */
	private store: Dexie.Table<any, string>;

	/**
	 * Content.
	 */
	private content: number;

	/**
	 * Scene
	 */
	private scene: Scene;

	/**
	 * Language.
	 */
	public language: string;

	/**
	 * Parent scene and hotspot path
	 */
	public path: string[] = [];

	/**
	 * Subscripton for the language.
	 */
	private languageSubscription: Subscription;

	/**
	 * Constructor.
	 */
	public constructor(
		private db: DexieService,
		private route: ActivatedRoute,
		private translateService: TranslateService,
		private sceneService: SceneService
	)
	{
		this.store = this.db.table('contents');
	}

	/**
	 * Lifecycle-Hook: OnInit.
	 */
	public ngOnInit()
	{
		this.route.parent.params.subscribe(parentParams => {

			this.content = +parentParams['content'];

			this.route.params.subscribe(params => {

				const activeTab = +params['tab'];

				// Get tab
				this.store.get({id: this.content}).then(content => {
					if (content && content.tabs)
					{
						const tabs = content.tabs;

						if (tabs.filter(item => item['id'] == activeTab).length > 0)
						{
							this.tab = tabs.find(item => item['id'] == activeTab);
						}
					}
				});

 				// Get scene and hotspot for title construction (see #31211)
				this.scene = this.sceneService.getCurrentScene();
				this.path = [];
				// Get scene title
				if (this.scene)
				{
					this.scene.path.forEach((item: (Segment | { [key: string]: string })) => {
						return this.path.push(item[this.translateService.currentLang]);
					});
					// Get hotspot title
					if (this.content)
					{
						let currentHotspots: Hotspot[] = this.scene.hotspots.filter((item: Hotspot) => item.content == this.content);
						const label = currentHotspots[0]['label'][this.translateService.currentLang];
						if (currentHotspots.length > 0)
						{
							this.path.push(label);
						}
					}
				}
			});
		});

		// Language.
		this.language = this.translateService.currentLang;
		this.languageSubscription = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
			this.language = event.lang;
		});

		// Cordova.
		if ((<any>window).cordova)
		{
			this.cordova = (<any>window).cordova;
		}
	}

	/**
	 * Lifecycle-Hook: OnDestroy.
	 */
	public ngOnDestroy()
	{
		this.languageSubscription.unsubscribe();
	}

	/**
	 * Open an URL.
	 */
	public onOpenLink(url: string)
	{
		if ((<any>window).cordova)
		{
			cordova.InAppBrowser.open(url, '_blank', 'location=yes,allowInlineMediaPlayback=yes');
		}
		else
		{
			window.open(url, '_blank');
		}
	}
}



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/components/tab/tab.component.ts